import PropTypes from "prop-types"

export const ElementJumpAttributePropTypes = PropTypes.shape({
  jumpId: PropTypes.number,
  jumpIdentifier: PropTypes.string,
  historical: PropTypes.bool
})

export const FormElementPropTypes = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  jumpAttribute: PropTypes.arrayOf(ElementJumpAttributePropTypes)
})

export const FormPagePropTypes = PropTypes.shape({
  title: PropTypes.object,
  elementsIds: PropTypes.arrayOf(PropTypes.string)
})

export const CustomFieldPropTypes = PropTypes.shape({
  elementNumber: PropTypes.number.isRequired,
  element: FormElementPropTypes.isRequired,
  onBlur: PropTypes.func.isRequired
})

export const UserFormElementPropTypes = PropTypes.shape({
  isSibling: PropTypes.bool,
  elementNumber: PropTypes.number.isRequired,
  element: FormElementPropTypes.isRequired,
  onBlur: PropTypes.func.isRequired
})

export const UserFormRowPropTypes = PropTypes.shape({
  rowElements: PropTypes.array.isRequired,
  onBlur: PropTypes.func.isRequired,
  elementsNumbers: PropTypes.object.isRequired
})

export const AdminDialogProps = PropTypes.shape({
  open: PropTypes.bool,
  close: PropTypes.func,
  submit: PropTypes.func,
  duplication: PropTypes.bool,
  formToDuplicate: PropTypes.object
})

export const AdminCustomForm = PropTypes.shape({
  _id: PropTypes.string,
  authorId: PropTypes.string,
  formIdentifier: PropTypes.string,
  frequency: PropTypes.oneOf([
    "daily",
    "weekly",
    "monthly",
    "quarterly",
    "semi-yearly",
    "yearly"
  ]),
  type: PropTypes.oneOf(["simple", "periodic", "persistent"]),
  signable: PropTypes.bool,
  elements: PropTypes.arrayOf(FormElementPropTypes),
  rows: PropTypes.arrayOf(PropTypes.string),
  pages: PropTypes.arrayOf(FormPagePropTypes)
})
